'use client';

import { ChakraProps, chakra } from '@chakra-ui/react';

export const Alert = () => {
  const highlight: ChakraProps['color'] = 'dynamic.highlight';

  return (
    <chakra.svg
      xmlns="http://www.w3.org/2000/svg"
      data-name="Layer 1"
      viewBox="0 0 930.67538 521.87593"
    >
      <chakra.path
        data-name="Path 133"
        d="M213.373 618.976a158.393 158.393 0 0028.727 33.862c.254.232.515.453.776.681l23.739-14.105c-.176-.239-.37-.506-.578-.8-12.394-17.255-68.372-132.055-68.714-157.478-.043 2.105-20.145 81.116 16.05 137.84z"
        transform="translate(-134.662 -189.062)"
        fill="#e6e6e6"
      />
      <chakra.path
        data-name="Path 134"
        d="M237.52 655.56c.366.164.74.324 1.118.477l17.81-10.582c-.279-.16-.603-.35-.975-.563-6.097-3.561-24.237-14.262-42.099-25.917-19.191-12.526-38.07-26.145-41.347-33.188.682 1.622 21.813 50.872 65.493 69.772z"
        transform="translate(-134.662 -189.062)"
        fill="#e6e6e6"
      />
      <chakra.path
        data-name="Path 133"
        d="M989.863 665.256a158.394 158.394 0 01-7.4 43.785c-.1.329-.211.653-.32.982h-27.612c.029-.295.059-.624.088-.982 1.84-21.166-8.677-148.453-21.37-170.483 1.113 1.787 58.755 59.444 56.614 126.698z"
        transform="translate(-134.662 -189.062)"
        fill="#e6e6e6"
      />
      <chakra.path
        data-name="Path 134"
        d="M987.79 709.04c-.23.33-.47.659-.717.983h-20.716c.157-.28.34-.61.55-.982 3.422-6.176 13.551-24.642 22.953-43.785 10.1-20.572 19.374-41.924 18.593-49.652.242 1.742 7.234 54.876-20.663 93.437z"
        transform="translate(-134.662 -189.062)"
        fill="#e6e6e6"
      />
      <chakra.path
        d="M448.068 520.193H128.74a28.58 28.58 0 01-28.548-28.548V28.548A28.58 28.58 0 01128.74 0h319.328a28.58 28.58 0 0128.548 28.548v463.097a28.58 28.58 0 01-28.548 28.548z"
        fill="#cacaca"
      />
      <chakra.path
        d="M448.63 501.979H128.178a8.81 8.81 0 01-8.8-8.8V27.014a8.81 8.81 0 018.8-8.8H448.63a8.81 8.81 0 018.8 8.8V493.18a8.81 8.81 0 01-8.8 8.8z"
        fill="#fff"
      />
      <circle cx={287.18951} cy={8.74274} r={2.42854} fill="#fff" />
      <chakra.path
        d="M929.485 521.876H1.19a1.19 1.19 0 110-2.381h928.294a1.19 1.19 0 110 2.381z"
        fill="#cacaca"
      />
      <circle cx={288.40115} cy={355.3465} r={31} fill="#e4e4e4" />
      <chakra.path
        d="M307.81 295.846h-38.817l-23.434-114.63a43.06 43.06 0 1185.692-.05z"
        fill="#e4e4e4"
      />
      <chakra.path
        d="M440.918 141.766h141.874a30.16 30.16 0 0129.42 23.527L683.9 483.26a24.375 24.375 0 01-22.58 29.707l-145.847 7.185a32.203 32.203 0 01-33.273-26.431l-40.664-224.807-7.692-42.523-11.351-62.752a18.57 18.57 0 0118.426-21.874z"
        fill="#3f3d56"
      />
      <chakra.path
        d="M564.114 148.62h16.561a20.843 20.843 0 0120.364 16.4l68.809 315.374a12.915 12.915 0 01-11.774 15.64L512.7 505.562a16.726 16.726 0 01-17.555-13.725l-58.715-325.97a14.65 14.65 0 0114.418-17.246h15.71a6.914 6.914 0 016.676 5.116 6.104 6.104 0 005.894 4.517h74.584a10.434 10.434 0 0010.403-9.633z"
        fill="#fff"
      />
      <chakra.path
        d="M637.487 249.714a10.525 10.525 0 011.316 1.007l48.056-12.25 3.279-11.594 18.143 2.66-3.81 21.089a8 8 0 01-7.034 6.533l-56.111 5.91a10.497 10.497 0 11-3.84-13.355z"
        fill="#ffb6b6"
      />
      <chakra.circle cx={603.19202} cy={262.1948} r={31} fill={highlight} />
      <chakra.path
        d="M622.6 202.695h-38.816L560.35 88.065a43.06 43.06 0 1185.692-.051z"
        fill={highlight}
      />
      <chakra.path
        fill="#3f3d56"
        d="M711.524 240.061L699.144 250.741 681.824 265.671 674.174 226.531 673.374 222.461 672.744 219.231 690.294 188.661 704.924 189.501 705.924 189.561 705.944 189.781 706.174 191.831 709.174 218.811 709.244 219.461 711.524 240.061z"
      />
      <chakra.path
        fill="#ffb6b6"
        d="M630.606 507.736L618.346 507.735 612.513 460.447 630.608 460.448 630.606 507.736z"
      />
      <chakra.path
        d="M633.732 519.62l-39.53-.002v-.5a15.387 15.387 0 0115.386-15.386l24.145.001z"
        fill="#2f2e41"
      />
      <chakra.path
        fill="#ffb6b6"
        d="M758.606 508.736L746.346 508.735 740.513 461.447 758.608 461.448 758.606 508.736z"
      />
      <chakra.path
        d="M761.732 520.62l-39.53-.002v-.5a15.387 15.387 0 0115.386-15.386l24.145.001zM768.404 487.911l-33 5-48.01-162.48-50.99 163.48-37-5 48-190v-15l6.5-22.5-.68-6.09-4.73-42.59-2.05-18.47-.133-1.193a4.056 4.056 0 013.193-4.417l15.4-3.24h25.17l14.85 4.09 1.02.28.46.13-.23 1.92-3.48 29.18-.19 1.6-3.36 28.13-.74 6.17c29 21 30 42 30 42z"
        fill="#2f2e41"
      />
      <circle cx={674.44747} cy={148.19876} r={24.56103} fill="#ffb6b6" />
      <chakra.path
        transform="rotate(-7.451 -708.117 1386.567)"
        fill="#3f3d56"
        d="M786.56648 443.4734H835.56648V450.4734H786.56648z"
      />
      <chakra.path
        d="M586.487 259.714a10.525 10.525 0 011.316 1.007l48.056-12.25 3.279-11.594 18.143 2.66-3.81 21.089a8 8 0 01-7.034 6.534l-56.111 5.909a10.497 10.497 0 11-3.84-13.355z"
        fill="#ffb6b6"
      />
      <chakra.path
        d="M660.404 194.911l-8.5-6.5c-2.298-.871-5.447 1.605-6 4l-12 49 25 18 3.5-5.5z"
        fill="#3f3d56"
      />
      <chakra.path
        d="M709.174 218.811a67.676 67.676 0 01-6.48 2.2c-.7.21-1.42.41-2.13.6a66.019 66.019 0 01-14.34 2.32 45.14 45.14 0 01-6.26-.17 35.243 35.243 0 01-6.59-1.3l-.22-.06a28.906 28.906 0 01-11.95-6.79 23.56 23.56 0 01-2.11-2.35 21.239 21.239 0 01-4.56-16.53 14.153 14.153 0 01.34-1.57 25.107 25.107 0 011.49-4.1c.27-.62.57-1.23.89-1.83l11.3-3.82h21.52l14.85 4.09 1 .06.02.22.46.13-.23 1.92z"
        opacity={0.2}
      />
      <chakra.path
        d="M655.627 127.865c-4.593-.563-9.634-.165-13.214 2.767s-4.736 9.028-1.346 12.178c3 2.79 7.693 2.134 11.713 2.927a15.854 15.854 0 0112.383 15.156c-.06 10.174-9.824 17.88-11.578 27.901-1.197 6.84 1.688 14.038 6.675 18.87s11.844 7.442 18.751 8.15 13.893-.373 20.606-2.148c6.741-1.782 13.378-4.31 19.034-8.388s10.293-9.826 12.11-16.558.512-14.45-4.168-19.62c-5.36-5.919-14.275-7.954-18.91-14.455-5.197-7.288-3.274-17.666-7.48-25.568-2.807-5.275-8.124-8.873-13.791-10.768s-11.72-2.27-17.692-2.453c-3.14-.097-6.376-.129-9.3 1.016s-5.497 3.753-5.649 6.89 1.856 4.103 1.856 4.103z"
        fill="#2f2e41"
      />
    </chakra.svg>
  );
};
